import Joi from 'joi';

import {constantsRegex} from "../constants/constants.regex";

export const editProfileCleanerValidator = Joi.object({
    last_name: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    first_name: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    email: Joi.string().pattern(constantsRegex.EMAIL).required().messages({
        'string.empty': 'Заповніть це поле',
        'string.pattern.base': 'Невалідний email',
    }),
    mobile_nummer: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    password: Joi.string().allow('').min(8).optional().messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів'
    }),
    confirm_password: Joi.string().min(8).valid(Joi.ref('password')).optional().messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів'
    }),
    taxpayer_number: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
    credit_cart_number: Joi.string().required().optional().messages({
        'string.empty': 'Заповніть це поле',
    }),
});
